module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('p', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contenttoc#t4",
      "id": "c4"
    }
  }, [_vm._v("CHAPTER 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/contenttoc#t4"
    }
  }, [_vm._v("Unthinkable Odds")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("A doctor rushed in. He seemed to be looking for someone. Me, I guessed, but since I was behind the reception counter, he seemed confused. When he noticed me and recovered, he thrust his hand into mine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m Dr. Hulda,” he said. “Your husband is in very good shape.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Relief washed over me, until—")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He’ll make a good organ donor.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What?!” I shook my head. My body began to tremble. I wanted to shout, “"), _c('i', [_vm._v("No! No!")]), _vm._v(" You’re supposed to save him. He’s "), _c('i', [_vm._v("not")]), _vm._v(" going to be an organ donor!” But I stood planted. More thoughts whirred through my brain. I vaguely remembered David telling me that he intended to be a donor. I knew there was a section on the New Jersey driver’s license where one could check organs to donate—eyes, kidney, heart, liver, etc. I had not opted to be a donor, but I knew David had. I was secretly relieved I had forgotten his wallet. It was safe at home on his desk.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Thinking fast, I managed to say, “Uhh, I don’t believe he chose that.” I knew donating organs was an unselfish and honorable act. If I or someone I cared about were in need, I would be grateful to a donor, but I couldn’t stop the ungenerous "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("thoughts. Perhaps the doctor’s eagerness raised a red flag. I wondered if he had someone waiting for a set of eyes or a heart. David’s heart? No! That belonged to me. I wondered if the doctor would fight as hard to save David’s life if he had another patient in the wings who would benefit from David’s organs.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("I again proclaimed, “David didn’t want that.” I wonder now, if I had not insisted, would David’s eyes be looking out of someone else’s body? Would his heart beat for a new love? I do not regret my white lie.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dr. Hulda told me that he had seen David’s CT scan on his home computer and came immediately. He explained that David had suffered a cerebellar hemorrhage. Blood was filling his brain and causing intense pressure. The pressure needed to be released to minimize the damage. Dr. Hulda laid out options for me, and none was desirable. He said that another CT scan could determine if the pressure was easing, but it would waste valuable time if it were not. Another option was immediate surgery.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I must have looked like a zombie. I stood mute, wringing my hands, breathing out and in and out again. I didn’t know what to do. I felt paralyzed. My permission was needed to operate on my husband’s brain. How could I give it? How could I allow Dr. Hulda to work on my husband’s beautiful, smart brain?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dr. Hulda watched my pain and indecision and said, “Come. Let me show you.” I followed him to an office around the corner. With a few quick taps of his fingers, the computer screen lit up with what looked like a skull. Dr. Hulda outlined the dark section and explained it was blood filling David’s skull.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("I stared. "), _c('i', [_vm._v("This can’t be happening")]), _vm._v(", I thought. "), _c('i', [_vm._v("How can this be real?")]), _vm._v(" I felt trapped in a science fiction movie. Brain surgery! I ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("tried to focus. My brain felt like the one I was gaping at on the screen—completely useless. Again Dr. Hulda outlined my options and gave me survival percentages. He said we could gamble and do another CT scan. If the pressure had diminished—good. However, if it had not and was becoming more intense, then David would have a one in six hundred chance of living. "), _c('i', [_vm._v("Unthinkable odds")]), _vm._v(", I thought. He went on to say that if David went immediately to surgery, his possibility of survival was better—one in twenty.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Still unthinkable! I stood there, panicky. How could I sign on the dotted line? What if I signed and David died on the table? What if I did not sign and he died anyway? I was in a no-win situation. I signed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Go!” I said. “Do the operation.” I called after him, “Remember, he’s my best friend in all the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dr. Hulda canceled the CT scan and sent David directly to the operating room. I watched as Dr. Hulda dashed off to scrub. Soon he would open my husband’s skull.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I vaguely remember following the attendant who pushed David’s bed through the hospital corridors. He pushed David into a room with a large machine at its center. I watched through the wall-length window as the attendants, seemingly in slow motion, transferred David from his bed to a table. It didn’t look like an operating room, at least not any I had seen in movies. I paced the length of the room, never taking my eyes off of David. Then the phone jangled, jarring me from my numbness. Though I was not able to hear the speaker, I knew something was wrong. I saw the nurse glance at David. Then like a bolt of lightning it struck me. This was the CT scan room!")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("“Oh no!” I nearly screamed. “Is that a CT scan machine?” Realizing it was, I did scream. “No! No! David’s not supposed ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("to be here. Dr. Hulda canceled the CT scan.” The nurse looked confused. “We decided to go ahead with the surgery—immediately. He canceled the CT scan!” I repeated.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Now the nurses looked panicked. They quickly returned David to the bed, while assuring me that the operating room was just across the hall. I was not consoled. I fretted over time lost. As they pushed David through the operating room doors, I touched him—gently, as if I were afraid he would break. But he was already broken. I let him go with my love.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba5663e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter04.vue
// module id = 90
// module chunks = 0